module.exports = __webpack_public_path__ + "img/input-count-plus.c6f1906f.svg";